import styled from "styled-components";

export const SelectItemGeradorCertificado = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  img {
    border: 1px solid white;
  }
  display: flex;
  flex-direction: row;
  padding: 10px;
  align-items: center;
`;
